import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22.009 11a3 3 0 0 0-3-3h-4.342a4 4 0 0 0-3.976 3.563A115.165 115.165 0 0 0 10 24.07c-.003 4.154.22 8.276.67 12.367A4 4 0 0 0 14.645 40h4.363a3 3 0 0 0 3-3V11Zm16 13.07a115.169 115.169 0 0 0-.691-12.507A4 4 0 0 0 33.342 8H29a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h4.363a4 4 0 0 0 3.977-3.563c.449-4.091.672-8.213.669-12.367Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPauseFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PauseFilled_default = SvgPauseFilled;

export { PauseFilled_default as default };
